import { defineStore } from 'pinia'
import { kebabToCamel } from '@/utils/helpers'
import { useLocalStorage } from '@vueuse/core'

export const useWidgetStore = defineStore('widget', {
  state: () => ({
    webSocket: null,
    chatSessionId: useLocalStorage('chatSessionId', null),
    participantId: useLocalStorage('participantId', null),
    participantKey: useLocalStorage('participantKey', null),
    // showChatWindow: useLocalStorage('showChatWindow', 'hide'),
    fileLimits: useLocalStorage('fileLimits', ''),
    connectedToAgent: useLocalStorage('connectedToAgent', false),
    messageHistory: useLocalStorage('messageHistory', null),
    eligibleChat: useLocalStorage('eligibleChat', false),
    enableSoftSearch: useLocalStorage('enableSoftSearch', false),
    chatExpanded: useLocalStorage('chatExpanded', false),
    brandingColor: '#005DAA',
    prechatFormData: useLocalStorage('prechatFormData', []),
    loggedInUserFormData: useLocalStorage('loggedInUserFormData', {}),
    prechatDisclaimerMessage: useLocalStorage('prechatDisclaimerMessage', null),
    supportAnchorLinkFS: useLocalStorage('supportAnchorLinkFS', ''),
    dataCollectionStatuses: useLocalStorage('dataCollectionStatuses', []),
    lastActivityTime: useLocalStorage('lastActivityTime', Date.now()),
    dataCollectionForms: useLocalStorage('dataCollectionForms', []),
    chatStarted: useLocalStorage('chatStarted', false),
    chatMinimized: useLocalStorage('chatMinimized', false),
    unreadMessages: useLocalStorage('unreadMessages', 0),
    chatInitialMessage: useLocalStorage('chatInitialMessage', 'You said'),
    darkProdFlag: useLocalStorage('darkProdFlag', false)
  }),
  getters: {
    // showChat: (state) => (state.showChatWindow || localStorage.getItem('show')) === 'show',
    // showPrechatForm: (state) => state?.prechatFormData?.length > 0,
    sessionId: (state) => state.chatSessionId === 'null' ? JSON.parse(state.chatSessionId) : state.chatSessionId,
    activeDataCollectionStatus: (state) => (id) => state.dataCollectionStatuses.includes(id),
    getDataCollectionFormModel: (state) => (id) => {
      if (!id) return
      return state.dataCollectionForms.find(f => f.id === id)
    },
    chatMinimizedState: (state) => {
      return state.chatMinimized === true ? 'none' : 'block'
    },
    getUnreadMessages: (state) => {
      return state.unreadMessages
    }
  },
  actions: {
    // setShowChat (show) {
    //   this.showChatWindow = show
    // },
    setSessionData ({ sessionId, participantId, participantKey }) {
      localStorage.setItem('chatSessionId', sessionId)
      localStorage.setItem('participantId', participantId)
      localStorage.setItem('participantKey', participantKey)
      this.participantId = participantId
      this.chatSessionId = sessionId
      this.participantKey = participantKey
    },
    setMessageHistory (messages) {
      this.messageHistory = messages
    },
    setWebSocket (socket) {
      localStorage.setItem('webSocket', JSON.stringify(socket))
      this.webSocket = socket
    },
    setFileLimits (limits) {
      const fileLimits = kebabToCamel(limits)
      fileLimits.uploadFileTypes = fileLimits?.uploadFileTypes?.split(':')

      this.fileLimits = JSON.stringify(fileLimits)
    },
    setConnectedToAgentStatus (state) {
      this.connectedToAgent = state
    },
    setEligibleChat (state) {
      this.eligibleChat = state
    },
    setEnableSoftSearch (state) {
      this.enableSoftSearch = state
    },
    setChatExpanded (state) {
      this.chatExpanded = state
    },
    setPreChatFormData (state) {
      this.prechatFormData = state
    },
    setLoggedInUserFormData (state) {
      this.loggedInUserFormData = state
    },
    clearLoggedInUserFormData () {
      this.loggedInUserFormData = {}
    },
    setPrechatDisclaimerMessage (state) {
      this.prechatDisclaimerMessage = state
    },
    setSupportAnchorLinkFSData (state) {
      this.supportAnchorLinkFS = state
    },
    setDataCollectionStatus (state) {
      this.dataCollectionStatuses.push(state)
    },
    setLastActivityTime (state) {
      this.lastActivityTime = state
    },
    clearDataCollectionStatuses () {
      this.dataCollectionStatuses = []
    },
    setDataCollectionForm ({ form, id }) {
      const index = this.dataCollectionForms.findIndex(f => f.id === id)
      if (index === -1) {
        this.dataCollectionForms.push({ form: form, id: id })
      } else {
        this.dataCollectionForms.splice(index, { form: form, id: id })
      }
    },
    clearDataCollectionForms () {
      this.dataCollectionForms.length = 0
    },
    setChatStarted (state) {
      this.chatStarted = state
    },
    setChatMinimized (state) {
      this.chatMinimized = state
    },
    setChatInitialMessage (state) {
      this.chatInitialMessage = state
    },
    setUnreadMessages (state) {
      if (state === 0) {
        this.unreadMessages = 0
      } else {
        this.unreadMessages += 1
      }
    },
    setDarkProdFlag (state) {
      this.darkProdFlag = state
    }
  }
})
